import { FC } from "react"
import { useTranslation } from "react-i18next"

import ShippingOrderSegmentModel from "models/ShippingOrderSegment"
import { ShippingOrderType } from "models/ShippingOrder"
import { Flex, FlexItem } from "components/Flex"
import NoValue from "components/NoValue/NoValue"

interface IShippingOrderTransportSegmentProps {
    segment: ShippingOrderSegmentModel
    noItems: boolean
    shippingOrderType: ShippingOrderType
}

const ShippingOrderTransportSegment: FC<IShippingOrderTransportSegmentProps> = ({
    segment,
    noItems,
    shippingOrderType,
}) => {
    const { t } = useTranslation()
    const fromToLabel = t(shippingOrderType === ShippingOrderType.return ? 'common.to' : 'common.from')
    const locationDescription = (shippingOrderType === ShippingOrderType.return
        ? segment.arrivalLocation?.description
        : segment.departureLocation?.description) || ""
    const dateLabel = (shippingOrderType === ShippingOrderType.return
        ? segment.arrivalDate.format(t('config.dateLongTimeFormat'))
        : segment.departureDate.format(t('config.dateLongTimeFormat'))) || ""

    return (
        <Flex alignItems="center" justifyContent="space-between" gap="0.8rem" className="py-1-5">
            <FlexItem>
                {locationDescription
                    ? `${fromToLabel} ${locationDescription}, `
                    : ''
                }
                {dateLabel}
            </FlexItem>
            <FlexItem shrink={0}>
                {segment.completionReportUri
                    ? <a href={segment.completionReportUri}
                        className="link color-brand-blue font-regular"
                        target="_blank"
                        rel="noreferrer">
                        {shippingOrderType === ShippingOrderType.delivery
                            ? t('shippingOrders.deliveryNote')
                            : t('shippingOrders.confirmationOfReceipt')}
                    </a>
                    : (noItems
                        ? <NoValue>
                            {t(shippingOrderType === ShippingOrderType.return
                                ? 'shippingOrders.noItemsStored'
                                : 'shippingOrders.noItemsReleased')
                            }
                        </NoValue>
                        : null)
                }
            </FlexItem>
        </Flex>
    )
}

export default ShippingOrderTransportSegment
